import React, { useState } from 'react';
import { css } from '@emotion/core';
import i18n from 'i18next';

import DialogSystem from 'client/components/DialogSystem';
import SocialShare, { modes } from 'client/components/Result/Share/SocialShare';

function ShareDialogWrapper({ url, children = () => {} }) {
    const [isOpen, setIsOpen] = useState(false);

    function handleOpen() {
        setIsOpen(true);
    }
    function handleClose() {
        setIsOpen(false);
    }

    return (
        <>
            {children({ onOpen: handleOpen })}
            <DialogSystem
                isOpen={isOpen}
                style={dialogStyle}
                title={i18n.t('label.share_media_work')}
                body={<SocialShare mode={modes.FULL} url={url} />}
                closePopup={handleClose}
            />
        </>
    );
}

export default ShareDialogWrapper;

const dialogStyle = css`
    min-width: 355px;
    & .MuiDialogContent-root > div {
        padding: 16px;
    }
    & .MuiDialogActions-root {
        display: none;
    }
`;
